import React, { useEffect, useState } from "react";
import { db } from "../../firebase/firebase";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import { useAuth } from "../../auth/AuthContext";

export default function ResellerRevenue(){

  const { user } = useAuth();
  const [summary, setSummary] = useState({});
  const [history, setHistory] = useState([]);

  useEffect(()=>{

    const load = async ()=>{

      // SUMMARY
      const summaryRef = doc(db, "resellers", user.resellerId, "revenue", "summary");
      const summarySnap = await getDoc(summaryRef);
      setSummary(summarySnap.exists() ? summarySnap.data() : {});

      // MONTHLY HISTORY
      const histRef = collection(db, "resellers", user.resellerId, "revenue");
      const histSnap = await getDocs(histRef);

      const list = [];
      histSnap.forEach(s => {
        if(s.id !== "summary"){
          list.push(s.data());
        }
      });

      setHistory(list.sort((a,b)=> (b.monthId||"") > (a.monthId||"") ? 1 : -1));
    };

    load();

  }, []);

  return(
    <div className="min-h-screen bg-gray-950 text-white px-6 py-10">

      <h1 className="text-3xl font-bold mb-8">Reseller Revenue</h1>

      <div className="grid md:grid-cols-3 gap-6 mb-10">

        <div className="bg-gray-900 p-6 rounded-xl border border-gray-800">
          <h3 className="text-gray-400 text-sm">Current MRR</h3>
          <p className="text-3xl font-bold text-green-400">£{summary.mrr || 0}</p>
        </div>

        <div className="bg-gray-900 p-6 rounded-xl border border-gray-800">
          <h3 className="text-gray-400 text-sm">Last Updated</h3>
          <p className="text-xl text-gray-300">{summary.lastUpdated ? summary.lastUpdated.toDate().toLocaleString() : "-"}</p>
        </div>

      </div>

      <h2 className="text-xl font-semibold mb-4">Monthly Breakdown</h2>

      <div className="bg-gray-900 p-6 rounded-xl border border-gray-800">

        {history.length === 0 && (
          <p className="text-gray-400">No revenue history yet.</p>
        )}

        {history.map(h => (
          <div className="py-4 border-b border-gray-800" key={h.monthId}>
            <p className="font-semibold">{h.monthId}</p>
            <p className="text-green-400">£{h.earnings || 0}</p>
          </div>
        ))}

      </div>

    </div>
  );
}
